import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {TarefaService} from "../../../services/tarefa-service";
import {ToastrService} from "ngx-toastr";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import Swal from "sweetalert2";
import {NovaTarefa} from "../../../models/nova-tarefa";
import {ProcessoService} from "../../../services/processo-service";
import {ListaProcesso} from "../../../models/lista-processo";

@Component({
    selector: 'app-novo-compromisso',
    templateUrl: './novo-compromisso.component.html',
    styleUrl: './novo-compromisso.component.css',
    standalone: false
})
export class NovoCompromissoComponent {
  @Output() atualizarListaDiario = new EventEmitter();
  showModal = false;
  salvando = false;
  formNovoCompromisso: FormGroup;
  novoCompromisso = new NovaTarefa();
  processos = new ListaProcesso();

 constructor(private tarefaService: TarefaService,
             private toastr: ToastrService,
             private processoService: ProcessoService,
             private formBuilder: FormBuilder) {
   this.construirFormulario();
   this.listarProcessos();
 }

 atualizarLista(){
   this.atualizarListaDiario.emit();
 }

 fecharModal(){
   this.formNovoCompromisso.reset();
   this.showModal = false;
 }

 abrirModal(data?: Date){
   this.showModal = true;
   if (data) {
     const offset = data.getTimezoneOffset() * 60000;
     const localISOTime = (new Date(data.getTime() - offset)).toISOString().slice(0, 16);
     this.formNovoCompromisso.patchValue({
       dataInicial: localISOTime
     });
   }
 }

  salvar(){
    this.preencherModel();
    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.isConfirmed){
        this.salvando = true;
        this.tarefaService.adicionar(this.novoCompromisso).subscribe(response => {
          this.salvando = false;
          if(response.sucesso){
            this.toastr.success('Compromisso salvo com sucesso!');
            this.fecharModal();
            this.atualizarLista();
          } else {
            this.toastr.error('Erro ao salvar compromisso!');
          }
        }, error => {
          this.salvando = false;
          this.toastr.error('Ocorreu um erro inesperado ao salvar o compromisso!');
        });
      }
    });
  }

 private preencherModel(){
   this.novoCompromisso.dataInicial = this.formNovoCompromisso.controls['dataInicial'].value;
   this.novoCompromisso.descricao = this.formNovoCompromisso.controls['descricao'].value;
   this.novoCompromisso.processoId = this.formNovoCompromisso.controls['processoId'].value;
   this.novoCompromisso.dataFinalizacao = this.formNovoCompromisso.controls['dataFinalizacao'].value;
   this.novoCompromisso.tipoTarefaId = 1;
 }

 private listarProcessos(){
   this.processoService.selecionarLista().subscribe(response => {
     if (response.sucesso) {
       this.processos = response.dados;
     } else {
       this.toastr.warning(response.errors[0].mensagem);
     }
   });
 }

  private construirFormulario(): void {
    this.formNovoCompromisso = this.formBuilder.group({
     descricao: ['', Validators.required],
     processoId: [null],
     dataInicial: ['', Validators.required],
     dataFinalizacao: ['', Validators.required]
    });
  }
}
